import { IKpData } from '../types/offer';

export interface IVillageSummaryInfoItem {
  key: string;
  title: string;
  value: string | number;
}

export const VILLAGE_CLASS_TITLE_MAP = {
  economy: 'Эконом',
  comfort: 'Комфорт',
  business: 'Бизнес',
  elite: 'Элитный',
};

export function getVillageSummaryInfo(kp: IKpData): IVillageSummaryInfoItem[] {
  const { villageClass, counterSet } = kp;
  const { total, onSale, sold, underConstruction } = counterSet;

  return [
    {
      key: 'villageClass',
      title: 'Класс',
      value: VILLAGE_CLASS_TITLE_MAP[villageClass],
    },
    {
      key: 'total',
      title: 'Объектов',
      value: total,
    },
    {
      key: 'onSale',
      title: 'В продаже',
      value: onSale,
    },
    {
      key: 'sold',
      title: 'Куплено',
      value: sold,
    },
    {
      key: 'underConstruction',
      title: 'Строится',
      value: underConstruction,
    },
  ];
}
